import React from 'react';
import MainLayout from '../../../templates/MainLayout';
import Home from './Home';

export default function HomePage() {
    return (
        <MainLayout Component={Home} />
    )
}